import { ShipmentEventType } from '../shipmentEvent/ShipmentEventType';

export class ShipmentBatchEvent {
  eventType?: ShipmentEventType;
  comment?: string;
  eventDate?: Date;

  constructor(opts?: Partial<ShipmentBatchEvent>) {
    if (opts?.eventType != null) {
      if (typeof opts?.eventType === 'string') {
        this.eventType = ShipmentEventType[opts.eventType];
      } else {
        this.eventType = opts.eventType;
      }
    }
    if (opts?.comment != null) {
      this.comment = opts.comment;
    }
    if (opts?.eventDate != null) {
      this.eventDate = new Date(opts.eventDate);
    }
  }
}
